module.exports = __webpack_public_path__ + "img/banner2.2ffd6b02.png";